<template>
  <a-card class="install-ly">
    <Breadcrumb routeName="MemberList" toName="资料详情" goPathName="成员列表"></Breadcrumb>
    <a-form :form="form">
      <a-card :bordered="false" title="基础数据" :bodyStyle="{paddingTop:'10px'}">
        <a-form-item label="累计销售" v-bind="formItemLayout" style="margin-bottom:0;">￥{{ staffDetail.paidFeeCount }}
        </a-form-item>
        <a-form-item label="累计佣金" v-bind="formItemLayout" style="margin-bottom:0;">
          ￥{{ staffDetail.commissionCount }}
        </a-form-item>
        <a-form-item label="累计订单数" v-bind="formItemLayout" style="margin-bottom:0;">{{ staffDetail.orderCount }}
        </a-form-item>
        <a-form-item label="可提现金额" v-bind="formItemLayout" style="margin-bottom:0;">
          ￥{{ staffDetail.accountAbleDrawCash }}
        </a-form-item>
        <a-form-item label="注册时间" v-bind="formItemLayout" style="margin-bottom:0;">{{ staffDetail.staffAddTime }}
        </a-form-item>
        <a-form-item label="添加方式" v-bind="formItemLayout" style="margin-bottom:0;">{{ staffDetail.staffSouceStr }}
        </a-form-item>
        <a-form-item label="提现方式" v-bind="formItemLayout" style="margin-bottom:0;">
          {{ staffDetail.staffDrawTypeStr }}
        </a-form-item>
        <a-form-item label="关联来源" v-if="staffDetail.inviteStaffName" v-bind="formItemLayout"
                     style="margin-bottom:0;">上级：({{ staffDetail.inviteStaffName }}{{ staffDetail.inviteStaffPhone }})
        </a-form-item>
        <a-form-item label="登录密码" v-bind="formItemLayout" style="margin-bottom:0;">
          <a-popconfirm
            style="margin-left: 20px"
            title="是否要重置当前账号密码为a123456？"
            @confirm="resetPassWord()">
            <a>重置</a>
          </a-popconfirm>
        </a-form-item>
        <a-form-item label="所属运营商" v-bind="formItemLayout" style="margin-bottom:0;">
          {{ staffDetail.merchantName }}
        </a-form-item>
        <a-form-item label="成员分组" v-bind="formItemLayout" style="margin-bottom:0;">
          <a-tag
            v-for="(item ,index) in staffGroupList"
            :key="item"
            :style="{'margin-left': index===0?0:10+'px'}"
          >{{ item }}
          </a-tag>
          <a-button type="primary" style="margin-left: 20px" @click="groupEditor">管理分组</a-button>
        </a-form-item>
        <a-form-item label="可开分店" v-bind="formItemLayout" style="margin-bottom:0;" v-if="staffDetail.showQuotaNum">
          <span v-if="!isSupplement">
            {{ staffDetail.supplementQuotaNum ? staffDetail.supplementQuotaNum : 0 }}
            <a-button @click="isSupplement = true" type="link">修改</a-button>
          </span>
          <span v-else>
            <a-input-number :step="1" v-model="supplementQuotaNum" :min="0"/>
            <a-button @click="saveSupplementInfo" type="link">保存</a-button>
            <a-button @click="isSupplement = false" type="link">取消</a-button>
          </span>
        </a-form-item>
        <!--        <div v-if="isShowInfo">-->
        <!--          <a-form-item label="授信管理" style="margin-bottom:0;" v-bind="formItemLayout">-->
        <!--            可用额度：<span style="font-size: 18px;">￥30,000.00</span>-->
        <!--          </a-form-item>-->
        <!--          <a-form-item style="margin-bottom:0;" :wrapper-col="formItemLayoutBtn2.wrapperCol">-->
        <!--            已用额度：20,000.00-->
        <!--          </a-form-item>-->
        <!--          <a-form-item style="margin-bottom:0;" :wrapper-col="formItemLayoutBtn2.wrapperCol">-->
        <!--            总额度：50,000.00-->
        <!--            <a-button type="primary" style="margin-left: 30px">管理授信</a-button>-->
        <!--          </a-form-item>-->
        <!--        </div>-->
      </a-card>
      <a-card :bordered="false" title="分销资料">
        <a-form-item label="姓名" v-bind="formItemLayout">
          <a-input
            placeholder=" 请输入"
            v-decorator="['staffName', {rules: [{ required: true,message: '请输入姓名'}], validateTrigger: 'change,blur'}]"/>
        </a-form-item>
        <a-form-item label="手机号" v-bind="formItemLayout">
          <a-input
            placeholder=" 请输入"
            v-decorator="['staffMobile', {rules: [{ required: true,validator: handlePhoneInput }], validateTrigger: 'blur'}]"
          />
        </a-form-item>
        <a-form-item label="身份证号" v-bind="formItemLayout">
          <a-input
            placeholder=" 请输入"
            v-decorator="['staffCardNo',  {rules: [{ required: false,type: 'string', message: '请输入身份证号' }], validateTrigger: 'blur'} ]"
          />
        </a-form-item>
        <a-form-item label=" 身份证人像面" v-bind="formItemLayout">
          <div class="upload-box">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,1)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="staffCardPositive" :src="staffCardPositive" alt="avatar" class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingCardPositive? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <img src="https://imgb.woyoubooking.com/common/person_card.jpg"
                 :class="[staffCardPositive?'image-sample':'image-sample-1']">
          </div>
        </a-form-item>
        <a-form-item label=" 身份证国徽面" v-bind="formItemLayout">
          <div class="upload-box">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,2)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="staffCardRear" :src="staffCardRear" alt="avatar" class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingCardRear? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <img src="https://imgb.woyoubooking.com/common/nation_card.jpg"
                 :class="[staffCardRear?'image-sample':'image-sample-1']">
          </div>
        </a-form-item>
        <a-form-item label=" 店铺logo" v-bind="formItemLayout">
          <div class="upload-box">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              listType="picture-card"
              :showUploadList="false"
              @change="fileInfo=>handleChange(fileInfo,3)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="staffShopLogo" :src="staffShopLogo" class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingShopLogo? 'loading' : 'plus'"/>
              </div>
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item label="店铺名称" v-bind="formItemLayout">
          <a-input
            v-decorator="['staffShopName',  {rules: [{ required: false, message: '请输入店铺名称' }], validateTrigger: 'blur'} ]"
            placeholder="请输入"/>
        </a-form-item>
        <a-form-item label="客服名称" v-bind="formItemLayout">
          <a-input
            v-decorator="['staffServiceName',  {rules: [{ required: false, message: '请输入客服名称' }], validateTrigger: 'blur'} ]"
            placeholder="请输入"/>
        </a-form-item>
        <a-form-item label="客服电话" v-bind="formItemLayout">
          <a-input
            v-decorator="['staffServicePhone',  {rules: [{ required: false, message: '请输入客服电话' }], validateTrigger: 'blur'} ]"
            placeholder="请输入"
          />
        </a-form-item>
        <!-- defaultValue="1" -->
        <a-form-item label="提现方式" v-bind="formItemLayout">
          <a-select
            style="max-width: 400px"
            @change="onTransferModeChange"
            v-decorator="['staffTransferMode',  {rules: [{ required: false, message: '请选择提现方式' }], validateTrigger: 'blur'} ]"
          >
            <a-select-option
              v-for="item in transferModes"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}
            </a-select-option>
          </a-select>
          <span style="margin-left: 10px;" v-if="staffTransferMode===2">提现至绑定的微信账号零钱中</span>
        </a-form-item>
        <template v-if="staffTransferMode===1"><!--支付宝-->
          <a-form-item label="提现账户名" v-bind="formItemLayout">
            <a-input
              placeholder="提现账户名"
              v-decorator="['staffBankMan',  {rules: [{ required: false, message: '请选择提现方式' }], validateTrigger: 'blur'} ]"
            />
          </a-form-item>
          <a-form-item label="提现账号" v-bind="formItemLayout">
            <a-input
              placeholder="提现账户名"
              v-decorator="['staffBankAccount',  {rules: [{ required: false, message: '请选择提现方式' }], validateTrigger: 'blur'} ]"
            />
          </a-form-item>
        </template>
        <template v-else-if="staffTransferMode===3"><!--银联-->
          <a-form-item label="提现账户名" v-bind="formItemLayout">
            <a-input
              placeholder="提现账户名"
              v-decorator="['staffBankMan',  {rules: [{ required: false, message: '请选择提现方式' }], validateTrigger: 'blur'} ]"
            />
          </a-form-item>
          <a-form-item label="提现开户行" v-bind="formItemLayout">
            <a-input
              placeholder="提现开户行"
              v-decorator="['staffBankName',  {rules: [{ required: false, message: '请输入提现开户行' }], validateTrigger: 'blur'} ]"
            />
          </a-form-item>
          <a-form-item label="提现银行卡卡号" v-bind="formItemLayout">
            <a-input
              placeholder="提现银行卡卡号"
              v-decorator="['staffBankAccount',  {rules: [{ required: false, message: '请输入提现银行卡卡号' }], validateTrigger: 'blur'} ]"
            />
          </a-form-item>
          <a-form-item label="银行联行号" v-bind="formItemLayout">
            <a-input
              placeholder="银行联行号"
              v-decorator="['staffBankNumber',  {rules: [{ required: false, message: '请输入银行联行号' }], validateTrigger: 'blur'} ]"
            />
          </a-form-item>
        </template>
        <a-form-item v-bind="formItemLayoutBtn">
          <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
          <a-button @click="backEvent" :loading="saveLoading" style="margin-left: 10px">返回</a-button>
        </a-form-item>
      </a-card>
    </a-form>
    <a-modal
      title="成员分组"
      :width="800"
      :height="600"
      v-model="visible"
      @ok="onClose"
      @cancel=" onClose"
      :destroyOnClose='false'
    >
      <custom-page-table
        ref="table"
        :columns="columns"
        :requestPromise="getRequestPromise">
        <template slot="userStatus" slot-scope="rowItem">
          <!--账户状态:0表示禁用，1表示启用-->
          <span v-if="rowItem.text===0">
          <a-badge dot style="margin-right: 10px"></a-badge>
          禁用
        </span>
          <span v-else class="custom">
          <a-badge dot style="margin-right: 10px"/>
          正常
        </span>
        </template>
        <template slot="lastLoginTime" slot-scope="rowItem">{{ rowItem.text ? rowItem.text : '----' }}</template>
        <template slot="action" slot-scope="rowItem">
          <template v-if="rowItem.record.catalog===2">
            <a v-if="rowItem.record.status==='未加入'" @click="markEvent(rowItem.record)">标记</a>
            <a-popconfirm
              v-else-if="rowItem.record.status==='已加入'"
              title="是否要移除当前分组？"
              @confirm="removeEvent(rowItem.record)">
              <a>移除</a>
            </a-popconfirm>
          </template>
        </template>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixin from '../../../utils/mixins/formMixins'
import userHelper from '../../../utils/helper/userHelper'

export default {
  name: 'ShopDetail',
  mixins: [formMixin],
  components: { Breadcrumb },
  data() {
    return {
      staffId: 0,
      staffDetail: '',
      staffGroupList: [],
      transferModes: [],
      staffShopLogo: '',
      staffCardRear: '',
      staffCardPositive: '',
      staffTransferMode: '',
      loadingCardRear: false,
      loadingCardPositive: false,
      loadingShopLogo: false,
      lineItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      visible: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        },
        {
          title: '分组类型',
          dataIndex: 'catalogStr'
        },
        {
          title: '分组状态',
          dataIndex: 'status'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      initCount: 0,
      markChange: false,//标记变更
      supplementQuotaNum: 0,
      isSupplement: false,
      isShowInfo: false
    }
  },

  mounted() {
    this.transferModes = this.getAppConstants().getTransferModes()
  },
  activated() {
    this.resetForm()
    this.staffId = this.getPageParams().staffId
    this.getStaffDetail()
    // this.getOwn()
  },

  methods: {
    // getOwn(){
    //   this.getHttpServices().getUserService().post('api/v2/paySetUp/query/own')
    //     .then(res => {
    //       this.isShowInfo = res.ownSwitch
    //     }).catch(reason => this.showNetWorkErrorMessage(reason))
    // },
    saveSupplementInfo() {
      let parms = {
        staffId: this.staffDetail.staffId,
        staffShopNumber: parseInt(this.supplementQuotaNum)
      }
      this.getHttpServices().getUserService().post('staff/v2/updateShopNumber', parms)
        .then(res => {
          this.$message.success('修改成功')
          this.isSupplement = false
          this.getStaffDetail()
        }).catch(reason => this.showNetWorkErrorMessage(reason))

    },
    getRequestPromise(params) {
      params.merchantId = this.staffDetail.staffMerchantId
      params.staffId = this.staffId
      return this.getHttpServices().getUserService().post('staff/v2/getStaffGroupList', params)
    },
    getStaffDetail() {
      this.getHttpServices().getUserService().post('staff/v2/getStaffDetail', { staffId: this.staffId })
        .then(detail => {
          this.staffDetail = detail
          this.staffShopLogo = detail.staffShopLogo
          this.staffCardRear = detail.staffCardRear
          this.staffCardPositive = detail.staffCardPositive
          this.staffTransferMode = detail.staffTransferMode ? detail.staffTransferMode : 1
          this.staffGroupList = detail.staffGroupList
          const updateObj = {
            staffName: detail.staffName,
            staffMobile: detail.staffMobile,
            staffCardNo: detail.staffCardNo,
            staffShopName: detail.staffShopName,
            staffServiceName: detail.staffServiceName,
            staffServicePhone: detail.staffServicePhone,
            staffTransferMode: detail.staffTransferMode ? detail.staffTransferMode : 1
          }
          if (detail.staffTransferMode === 1) {//支付宝
            updateObj.staffBankMan = detail.staffBankMan
            updateObj.staffBankAccount = detail.staffBankAccount
          } else if (detail.staffTransferMode === 3) {//银行
            updateObj.staffBankMan = detail.staffBankMan
            updateObj.staffBankAccount = detail.staffBankAccount
            updateObj.staffBankName = detail.staffBankName
            updateObj.staffBankNumber = detail.staffBankNumber
          }
          this.$nextTick(() => this.form.setFieldsValue(updateObj))
          this.supplementQuotaNum = this.staffDetail.supplementQuotaNum ? this.staffDetail.supplementQuotaNum : 0
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onTransferModeChange(value) {
      this.staffTransferMode = value
      if (value === 1) {
        this.form.setFieldsValue({
          staffBankMan: undefined,
          staffBankAccount: undefined
        })
      } else if (value === 3) {
        this.form.setFieldsValue({
          staffBankMan: undefined,
          staffBankName: undefined,
          staffBankAccount: undefined,
          staffBankNumber: undefined
        })
      }
    },
    //文件变更监听
    handleChange(fileInfo, index) {
      if (fileInfo.file.status === 'uploading') {
        if (index === 1) {
          this.loadingCardPositive = true
        } else if (index === 2) {
          this.loadingCardRear = true
        } else if (index === 3) {
          this.loadingShopLogo = true
        }
      } else if (fileInfo.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(fileInfo.fileList)
        if (index === 1) {
          this.staffCardPositive = url
          this.loadingCardPositive = false
        } else if (index === 2) {
          this.staffCardRear = url
          this.loadingCardRear = false
        } else if (index === 3) {
          this.staffShopLogo = url
          this.loadingShopLogo = false
        }
      }
    },
    //重置密码
    resetPassWord() {
      const userPwd = userHelper.getPasswordEncrypt('a123456')
      const path = 'user/merchantStaff/resetPwd/' + this.staffId + '/' + userPwd
      this.getHttpServices().getUserService().post(path)
        .then(res => {
          this.$message.success('密码重置成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    saveEvent() {
      this.validateFormParams().then(values => {
        this.getLogUtils().logWithTag('params====', values)
        this.updateRequest(values)
      }).catch(reason => this.getLogUtils().errorWithTag('params====', reason))
    },
    updateRequest(values) {
      const params = {
        ...values,
        staffId: this.staffId,
        staffCardPositive: this.staffCardPositive,
        staffCardRear: this.staffCardRear,
        staffShopLogo: this.staffShopLogo
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('staff/v2/updateStaff', params)
        .then(res => {
          this.$message.success('数据更新成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    groupEditor() {
      this.visible = true
      this.initCount++
      if (this.initCount > 1) {
        this.$nextTick(() => {
          this.$refs.table.refresh(true)
        })
      }
    },

    markEvent(record) {
      this.updateGroupInfo(1, record.id)
    },
    removeEvent(record) {
      this.updateGroupInfo(2, record.id)
    },
    updateGroupInfo(operate, groupId) {
      const params = {
        groupId: groupId,
        operate: operate,// 1标记 2移除
        staffId: this.staffId
      }
      const tips = operate === 1 ? '标记成功' : '移除成功'
      this.getHttpServices().getUserService().post('staff/v2/markStaffGroup', params)
        .then(res => {
          this.$message.success(tips)
          this.$refs.table.refresh(false)
          this.markChange = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onClose() {
      this.visible = false
      if (this.markChange) {
        this.markChange = false
        this.getStaffDetail()
      }
    }
  }
}
</script>
<style lang="less">
@import "../../CustomPage";

.install-ly {
  .upload-box {
    margin-top: 14px;
    height: 104px;
    position: relative;
  }

  .selected-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 104px;
    height: 104px;
  }

  .image-sample {
    position: absolute;
    top: 0;
    left: 120px;
    height: 104px;
  }

  .image-sample-1 {
    position: absolute;
    top: 0;
    left: 112px;
    height: 104px;
  }

  input {
    max-width: 400px;
  }

  .single-import-box > .ant-upload {
    width: 180px;
    height: 104px;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}
</style>